import React, { useContext, useCallback } from "react";
import { UI } from "@wwimmo/ui";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { RootStoreContext } from "src/stores/RootStore";
import { useTranslation } from "react-i18next";
import { ApproveInvoiceModal } from "./modal/ApproveInvoiceModal";
import { APPROVE_REJECT_MODAL_TYPE } from "src/stores/krediflow/ApproveRejectInvoiceStore";

const ApproveInvoiceBase = () => {
    const { approveRejectInvoiceStore, invoiceStore } = useContext(RootStoreContext);
    const { t } = useTranslation();

    const displayApproveInvoiceModal = useCallback(() => {
        approveRejectInvoiceStore.setIsModalDisplayed(true);
        approveRejectInvoiceStore.setDisplayedModalType(APPROVE_REJECT_MODAL_TYPE.APPROVE);
    }, [approveRejectInvoiceStore]);

    return (
        <>
            <UI.Button
                label={t("screens.kredi_flow.action.approve")}
                className={"ApproveInvoiceButton mb-2"}
                onClick={displayApproveInvoiceModal}
                hidden={!invoiceStore.currentInvoice?.canCurrentUserApproveOrReject}
                disabled={
                    !invoiceStore.currentInvoice?.hasCurrentUserApproveOrRejectRightsForCurrentInvoiceState ||
                    invoiceStore.currentInvoice?.isProcessing
                }
            />
            <ApproveInvoiceModal />
        </>
    );
};

export const ApproveInvoice = Sentry.withProfiler(observer(ApproveInvoiceBase));
